import shim from './dh';

export default shim;
export { default as dh } from './dh';
export { default as PropTypes } from './PropTypes';
